export default __webpack_public_path__ + "static/media/gestaodepessoas.bef07e3c.svg";